import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Component, HostBinding, Input, Directive, ElementRef, Inject, EventEmitter, Output, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, Forward, mixinHideEvent, mixinShowEvent, hideEventOutput, showEventOutput, Track, FadvCommonModule, FadvSummaryIconDirective } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/accordion/accordion';

class FadvAccordionSummaryComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.slotName = 'summary';
    }
}
FadvAccordionSummaryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionSummaryComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvAccordionSummaryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvAccordionSummaryComponent, selector: "fadv-accordion-panel-summary", inputs: { summaryIconLibrary: "summaryIconLibrary", summaryIconName: "summaryIconName" }, host: { properties: { "slot": "this.slotName" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host{display:block;width:100%}\n"] });
__decorate([
    Forward()
], FadvAccordionSummaryComponent.prototype, "summaryIconLibrary", void 0);
__decorate([
    Forward()
], FadvAccordionSummaryComponent.prototype, "summaryIconName", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionSummaryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fadv-accordion-panel-summary', template: '<ng-content></ng-content>', styles: [":host{display:block;width:100%}\n"] }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }], summaryIconLibrary: [{
                type: Input
            }], summaryIconName: [{
                type: Input
            }] } });
class FadvAccordionPanelContentComponent extends FadvBaseComponent {
}
FadvAccordionPanelContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionPanelContentComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvAccordionPanelContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvAccordionPanelContentComponent, selector: "fadv-accordion-panel-content", usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionPanelContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-accordion-panel-content',
                    template: '<ng-content></ng-content>',
                }]
        }] });
class FadvAccordionSummaryActionsDirective {
    constructor() {
        this.slotName = 'actions';
    }
}
FadvAccordionSummaryActionsDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionSummaryActionsDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FadvAccordionSummaryActionsDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvAccordionSummaryActionsDirective, selector: "[fadvAccordionSummaryActions]", host: { properties: { "slot": "this.slotName" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionSummaryActionsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fadvAccordionSummaryActions]',
                }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });
class FadvAccordionPanelComponent extends mixinHideEvent(mixinShowEvent(FadvBaseComponent)) {
    constructor(el) {
        super(el);
        this.open = false;
        this.disabled = false;
    }
    _forwardShowEvent(event) {
        this.shown.emit(event);
    }
    _forwardHideEvent(event) {
        this.hidden.emit(event);
    }
}
FadvAccordionPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionPanelComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvAccordionPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvAccordionPanelComponent, selector: "fadv-accordion-panel", inputs: { open: "open", disabled: "disabled", summary: "summary" }, outputs: { hidden: "hidden", shown: "shown" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvAccordionPanelComponent.prototype, "open", void 0);
__decorate([
    Forward()
], FadvAccordionPanelComponent.prototype, "disabled", void 0);
__decorate([
    Forward()
], FadvAccordionPanelComponent.prototype, "summary", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionPanelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-accordion-panel',
                    template: '<ng-content></ng-content>',
                    outputs: [hideEventOutput, showEventOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { open: [{
                type: Input
            }], disabled: [{
                type: Input
            }], summary: [{
                type: Input
            }] } });

class FadvAccordionComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.panelsStayOpen = false;
        this.variant = 'default';
        this.panelShown = new EventEmitter();
        this.panelHidden = new EventEmitter();
    }
    _handlePanelShown(e) {
        const { detail } = e;
        this.panelShown.emit(detail);
    }
    _handlePanelHidden(e) {
        const { detail } = e;
        this.panelHidden.emit(detail);
    }
}
FadvAccordionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvAccordionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvAccordionComponent, selector: "fadv-accordion", inputs: { panelsStayOpen: "panelsStayOpen", variant: "variant" }, outputs: { panelShown: "panelShown", panelHidden: "panelHidden" }, host: { listeners: { "fadv-panel-show": "_handlePanelShown($event)", "fadv-panel-hide": "_handlePanelHidden($event)" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvAccordionComponent.prototype, "panelsStayOpen", void 0);
__decorate([
    Forward()
], FadvAccordionComponent.prototype, "variant", void 0);
__decorate([
    Track()
], FadvAccordionComponent.prototype, "panelShown", void 0);
__decorate([
    Track()
], FadvAccordionComponent.prototype, "panelHidden", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-accordion',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { panelsStayOpen: [{
                type: Input
            }], variant: [{
                type: Input
            }], panelShown: [{
                type: Output
            }], panelHidden: [{
                type: Output
            }], _handlePanelShown: [{
                type: HostListener,
                args: ['fadv-panel-show', ['$event']]
            }], _handlePanelHidden: [{
                type: HostListener,
                args: ['fadv-panel-hide', ['$event']]
            }] } });

class FadvAccordionModule {
}
FadvAccordionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvAccordionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionModule, declarations: [FadvAccordionComponent,
        FadvAccordionPanelComponent,
        FadvAccordionPanelContentComponent,
        FadvAccordionSummaryComponent,
        FadvAccordionSummaryActionsDirective], imports: [FadvCommonModule], exports: [FadvAccordionComponent,
        FadvAccordionPanelComponent,
        FadvAccordionPanelContentComponent,
        FadvAccordionSummaryComponent,
        FadvAccordionSummaryActionsDirective,
        FadvSummaryIconDirective] });
FadvAccordionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FadvAccordionComponent,
                        FadvAccordionPanelComponent,
                        FadvAccordionPanelContentComponent,
                        FadvAccordionSummaryComponent,
                        FadvAccordionSummaryActionsDirective,
                    ],
                    imports: [FadvCommonModule],
                    exports: [
                        FadvAccordionComponent,
                        FadvAccordionPanelComponent,
                        FadvAccordionPanelContentComponent,
                        FadvAccordionSummaryComponent,
                        FadvAccordionSummaryActionsDirective,
                        FadvSummaryIconDirective,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvAccordionComponent, FadvAccordionModule, FadvAccordionPanelComponent, FadvAccordionPanelContentComponent, FadvAccordionSummaryActionsDirective, FadvAccordionSummaryComponent };
